import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    background: 'linear-gradient(to right, #008F4D, #12223A)',
    [theme.breakpoints.up('sm')]: {
      width: '350px'
    }
  },
  closeButtonContainer: {
    heigth: 30,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 5
  },
  titleContainer: {
    borderRadius: 20,
    padding: 5,
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: '#00783B',
    display:'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& p': {
      fontSize: 20
    }
  },
  boxWithMargin: {
    marginLeft: 10,
    marginRight: 10
  },
  dividerContainer: {
    width: '100%',
    marginTop: 10,
    marginBottom: 10,
    color: 'black',
    backgroundColor: '#D4EBDE',
    display:'flex',
  },
  escribenosContainer: {
    marginTop: 20,
    marginBottom: 20,
    display:'flex',
    justifyContent: 'center'
  },
  whatsappButtonContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  whatsappButton: {
    color: 'white',
    backgroundColor: '#D52329',
    borderRadius: 10,
    display:'flex',
    justifyContent: 'center',
    padding: 5,
    cursor:'pointer',
    width: 'fit-content',
  },
  whiteText: {
    color: 'white',
    textAlign: 'center'
  },
  blackText: {
    color: 'black',
    textAlign: 'center',
    fontWeight:'bold'
  },
  villanuevaIconFooterContainer: {
    height: 75,
    display:'flex',
    justifyContent: 'center'
  }
}))
